import { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { Divider } from "@aws-amplify/ui-react";
import { Button, Grid, InputLabel, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { TextWithCount } from "components/Fields";
import NotInterestedOutlinedIcon from "@mui/icons-material/NotInterestedOutlined";

function StepFive(props) {
  const {
    errors,
    control,
    setValue,
    contracts,
    viewFields,
    setComments,
    setContracts,
    videoResponse,
  } = props;
  const [newContractName, setNewContractName] = useState("");
  const [newContractUrl, setNewContractUrl] = useState("");

  useEffect(() => {
    setValue("relatedFiles", contracts);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contracts]);

  const deleteContrato = (contrato) => {
    setContracts(contracts.filter((item) => item.name !== contrato.name));
  };

  useEffect(() => {
    if (videoResponse?.comments) {
      setComments(videoResponse?.comments);
      setValue("comments", videoResponse?.comments);
    }
    if (videoResponse?.relatedFiles?.length > 0) {
      setContracts(videoResponse?.relatedFiles);
      setValue("relatedFiles", videoResponse?.relatedFiles);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoResponse]);

  return (
    <div id="step-five">
      <div className="step-container">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div style={{ display: "flex" }}>
              <div className="video_label-title">Contratos dos conteúdos</div>
              <div className="video_label-title2"><span style={{fontSize:12, color:'#6082B6'}}>(Opcional)</span></div>
            </div>
            <TextWithCount
              name="comments"
              label="Observações gerais"
              placeholder="Observações gerais"
              maxLength={3000}
              control={control}
              disabled={viewFields}
              multiline
            />
          </Grid>
          <Grid item xs={12}>
            <svg
              width="17"
              height="15"
              viewBox="0 0 17 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.5039 0.888672C15.3164 0.888672 16.0039 1.57617 16.0039 2.38867V4.41992C16.0039 4.95117 15.5352 5.38867 15.0039 5.38867V12.8887C15.0039 14.0137 14.0977 14.8887 13.0039 14.8887H3.00391C1.87891 14.8887 1.00391 14.0137 1.00391 12.8887L0.972656 5.38867C0.441406 5.38867 0.00390625 4.95117 0.00390625 4.38867V2.38867C0.00390625 1.57617 0.660156 0.888672 1.50391 0.888672H14.5039ZM13.0039 13.3887C13.2539 13.3887 13.5039 13.1699 13.5039 12.8887V5.38867H2.50391V12.8887C2.50391 13.1699 2.72266 13.3887 3.00391 13.3887H13.0039ZM14.5039 3.88867V2.38867H1.50391V3.88867H14.5039ZM5.72266 8.38867C5.31641 8.38867 5.00391 8.07617 5.00391 7.63867C5.00391 7.23242 5.31641 6.88867 5.72266 6.88867H10.2539C10.6602 6.88867 11.0039 7.23242 11.0039 7.63867C11.0039 8.07617 10.6602 8.38867 10.2227 8.38867H5.72266Z"
                fill="#515D71"
              />
            </svg>

            <span className="video-subtitle">Arquivos do contrato</span>
            <Divider className="mr-divider" />
          </Grid>
        </Grid>
        {contracts &&
          contracts.length > 0 &&
          contracts.map((contract, index) => (
            <Grid container spacing={2} key={index} style={{ marginTop: 12 }}>
              <Grid item xs={5}>
                <Form.Group className="mb-3" controlId="formName">
                  <InputLabel className="select-label mr-select-label">
                    Nome do contrato
                  </InputLabel>
                  <span
                    style={{
                      display: "block",
                      fontSize: 16,
                      fontWeight: 400,
                      color: "rgba(25, 28, 31, 1)",
                      borderBottom: "1px solid rgba(208, 213, 221, 1)",
                    }}
                    id="video-contract-name-value"
                  >
                    {contract.name}
                  </span>
                </Form.Group>
              </Grid>
              <Grid item xs={5}>
                <Form.Group className="mb-3" controlId="formName">
                  <InputLabel className="select-label mr-select-label">
                    Arquivo
                  </InputLabel>
                  <span
                    style={{
                      display: "block",
                      fontSize: 16,
                      fontWeight: 400,
                      color: "rgba(25, 28, 31, 1)",
                      borderBottom: "1px solid rgba(208, 213, 221, 1)",
                    }}
                    id="video-contract-file-link-value"
                  >
                    {contract.url}
                  </span>
                </Form.Group>
              </Grid>

              <Grid
                item
                xs={2}
                style={{ display: "flex", alignItems: "center" }}
              >
                {!viewFields && (
                  <Button
                    color="error"
                    style={{
                      textTransform: "capitalize",
                      color: "rgba(255, 98, 98, 1)",
                    }}
                    startIcon={<NotInterestedOutlinedIcon />}
                    onClick={() => deleteContrato(contract)}
                    disabled={viewFields}
                    id="video-remove-contract-button"
                  >
                    Remover
                  </Button>
                )}
              </Grid>
            </Grid>
          ))}
        {!viewFields && (
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Form.Group
                className="mb-3"
                controlId="formName"
                id="video-contract_name"
              >
                <Controller
                  name={"contract_name"}
                  control={control}
                  render={({
                    field: { onChange, value, onBlur },
                    fieldState: { error, invalid, isTouched, isDirty },
                    formState,
                  }) => (
                    <TextField
                      className="mt-2"
                      fullWidth
                      id="video-contract-name"
                      placeholder="Nome do contrato"
                      variant="standard"
                      onChange={(e) => {
                        setNewContractName(e.target.value);
                      }}
                      value={newContractName}
                      aria-invalid={errors.contract_name ? "true" : "false"}
                      onBlur={(e) => {
                        // trigger(e.target.limit_views);
                      }}
                    />
                  )}
                />
              </Form.Group>
            </Grid>
            {!viewFields && (
              <Grid item xs={6}>
                <Form.Group
                  className="mb-3"
                  controlId="formName"
                  id="video-related_file_url"
                >
                  <Controller
                    name={"related_file_url"}
                    control={control}
                    render={() => (
                      <TextField
                        className="mt-2"
                        fullWidth
                        placeholder="Link do contrato"
                        id="video-contract-link"
                        variant="standard"
                        onChange={(e) => {
                          setNewContractUrl(e.target.value);
                        }}
                        value={newContractUrl}
                        aria-invalid={
                          errors.related_file_url ? "true" : "false"
                        }
                      />
                    )}
                  />
                </Form.Group>
              </Grid>
            )}
          </Grid>
        )}
        {!viewFields && (
          <Button
            style={{
              textTransform: "initial",
            }}
            disabled={!newContractName || !newContractUrl}
            component="label"
            onClick={(e) => {
              setContracts((prevState) => [
                ...prevState,
                { name: newContractName, url: newContractUrl },
              ]);
              setNewContractName("");
              setNewContractUrl("");
            }}
            id="video-add-contract-button"
          >
            + Adicionar
          </Button>
        )}
      </div>
    </div>
  );
}

export default StepFive;
